"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const zustandStore_1 = require("../../zustandStore");
const introductionActions_1 = require("./introductionActions");
const managementActions_1 = require("./managementActions");
const CookieActions = () => {
    const { cookies } = (0, zustandStore_1.useZustand)(state => ({ ...state }));
    const { showManageCookies } = cookies;
    return ((0, jsx_runtime_1.jsx)(material_1.DialogActions, { style: {
            justifyContent: 'center',
            padding: '0px 24px 24px',
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: '100%',
            width: '100%',
            boxSizing: 'border-box',
            gap: '10px',
        }, children: showManageCookies ? (0, jsx_runtime_1.jsx)(managementActions_1.ManagementActions, {}) : (0, jsx_runtime_1.jsx)(introductionActions_1.IntroductionActions, {}) }));
};
exports.CookieActions = CookieActions;
